// The values a trait breaks the answers down into. Resolving WHICH trait is active reaches for
// the report virtuals and the piping variables, so that chain stays with the page; what the
// resolved trait is made of is read here.

export const getTraitValues = trait => {
  if (!trait) return []
  const source = trait.values || trait.answerVariants || []
  return source.map(value => {
    // Chained && / || kept 1:1 with coffee: a falsy id (0, '') deliberately falls
    // through to position/raw — unlike ec's traitValues.js, which "fixed" that edge.
    const id =
      (Object.hasOwn(value, 'id') && value.id) || (Object.hasOwn(value, 'position') && `a${value.position}`) || value
    const name =
      (Object.hasOwn(value, 'name') && (value.name.en || value.name)) ||
      (Object.hasOwn(value, 'position') && `A${value.position}`) ||
      value
    return { id, name }
  })
}
